export default __webpack_public_path__ + "static/MaisonNeue-Book-915b3a16ab82c619e65b3ca0b6df3e16.woff";